import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from './serviceHelper'

export const currencyFieldService = {
  getCompanyData: async (user) => {
    return (await axios.get(`${NODE_BASE_URL}/template/company`, getAxiosOptions(user))).data[0]
  },
  addNonDefaultCurrency: async (user, payload) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/template/company/${user.company_id}`,
        payload,
        getAxiosOptions(user)
      )
    ).data
  },
  getNonDefaultCurrency: async (processId, user) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/template/company/get-nondefaultcurrency/${processId}`,
        getAxiosOptions(user)
      )
    ).data
  },
  deleteNonDefaultCurrency: async (user, processId, fieldId) => {
    return (
      await axios.delete(
        `${NODE_BASE_URL}/template/company/nondefaultcurrency/${processId}/${fieldId}`,
        getAxiosOptions(user)
      )
    ).data
  },
  deleteAllNonDefaultCurrencies: async (user, processId) => {
    return (
      await axios.delete(
        `${NODE_BASE_URL}/template/company/allnondefaultcurrency/${processId}`,
        getAxiosOptions(user)
      )
    ).data
  },
  getAllNonDefaultCurrenciesForDashboard: async (user, processTemplateId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/template/company/nondefaultcurrency/${processTemplateId}`,
        getAxiosOptions(user)
      )
    ).data
  },
  getAllNonDefaultCurriesImported: async (user, processTemplateId, processReferenceNum) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/template/company/imp-nondefaultcurrency/${processTemplateId}/${processReferenceNum}`,
        getAxiosOptions(user)
      )
    ).data
  },
}
